import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import useMatricula from "../hooks/useMatricula";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";
import ModalAutorizacion from "./Autorizaciones/ModalAutorizacion/ModalAutorizacion";
import Hora from "./Hora";

const Menu = () => {
  const { listadoEtiquetas } = useAuth();
  const { listadoRequisitosMatricula } = useMatricula();
  const [etiquetas, setEtiquetas] = useState({});
  const { pathname } = useLocation();

  useEffect(() => {
  
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        global_inicio: obtenerLabelEtiqueta(
          "lbl_global_inicio",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);
  const { global_inicio } = etiquetas;

  const handleClickInicio = (e) => {
    e.preventDefault();
    if (pathname === "/") {
      window.location.reload();
    } else {
      window.location.href = "/";
    }
  };

  const validarRequisitosAutorizacion = () => {
     

    let listado = listadoRequisitosMatricula.filter((data, index) => index > 0);

    let validarCheck =
      listado.length > 0 ? listado.every((e) => e.bcompletado === true) : false;

    return validarCheck;
  };
  return (
    <>
      <nav className="navbar navbar-dark d-sm-none d-md-block bg-primary-upch p-0">
        <div className="container d-flex justify-content-between">
          <ul className="nav navbar-nav d-inline-block">
            
            <li className="nav-item d-inline-block">
              <Link
                className="nav-link active"
                aria-current="page"
                to="/"
                onClick={handleClickInicio}
              >
                <i className="zmdi zmdi-home"></i> {global_inicio}
              </Link>
            </li>
            <li className="nav-item d-inline-block ">
             
            </li>
          </ul>

          <Hora />
        </div>
      </nav>

    
      
    </>
  );
};

export default Menu;
